import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/user-management/assistant`;

export const assistantsRoutesObj = {
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:assistantId`,
} as const;

export type IAssistantsRouteParams = IExtractRouteParamMap<
  typeof assistantsRoutesObj
>;

export const assistantsPath = createPaths<
  typeof assistantsRoutesObj,
  IAssistantsRouteParams
>(assistantsRoutesObj);
